module.exports = __webpack_public_path__ + "img/arrow-down.31b3187c.svg";